import { Component, OnInit } from '@angular/core';
import { WorldRankingFiltersService } from '../../../world-ranking/services/world-ranking-filters.service';
import { FiltersWorldRecordsService } from '../../services/filters-world-records.service';

@Component({
  selector: 'app-bootstrap-world-records',
  templateUrl: './bootstrap-world-records.component.html',
  styleUrls: ['./bootstrap-world-records.component.scss']
})
export class BootstrapWorldRecordsComponent implements OnInit {

  constructor(public world_records_service: FiltersWorldRecordsService) { }

  ngOnInit() {
  }

}
